import {makeAutoObservable} from "mobx";
import {LoginInfoEntity} from "../entity/login-info-entity";

export class LoginStore {

    public loginName:string = "";
    public loginPassword:string = "";
    public loginCode:string = "";
    public userInfo: LoginInfoEntity|undefined;
    public menuList: LoginInfoEntity|undefined;

    constructor() {
        makeAutoObservable(this, { loginName: false, loginPassword: false });
    }

    public setName(name: string) {
        this.loginName = name;
    }

    public setLoginPassword(password: string) {
        this.loginPassword = password;
    }

    public setLoginCode(code: string) {
        this.loginCode = code;
    }

    public setUserInfo(info: LoginInfoEntity) {
        this.userInfo = info;
    }

    public setMenuList(info: LoginInfoEntity) {
        this.menuList = info;
    }

    public clearFormData = () => {
        this.loginPassword = "";
        this.loginName = "";
    }

}